import { z } from 'zod'
import { EmailFieldSchema } from '../shared/email'

// POST /newsletter/subscribe (NewsletterRequest { Email }). A API repassa ao RD Station por uma URL fixa
// (api.unigloves.com.br/api/rd/newsletter) e responde 200 sem corpo ou 400 com texto.

/** Formulário do rodapé: o campo de e-mail comum dos formulários da loja. */
export const NewsletterSubscribeFormSchema = z.object({ email: EmailFieldSchema })

/** Corpo da requisição. */
export const NewsletterSubscribeRequestSchema = NewsletterSubscribeFormSchema

/** 200 sem corpo: nada a validar. */
export const NewsletterSubscribeResponseSchema = z.unknown()

export type INewsletterSubscribeForm = z.infer<typeof NewsletterSubscribeFormSchema>
export type INewsletterSubscribeRequest = z.infer<typeof NewsletterSubscribeRequestSchema>
